import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Typo, Input as _Input, Form } from 'tmt-ui-kit';
import Link from '~/components/Link/Link';
import PropTypes from 'prop-types';

const TitleForm = styled(Typo.HeaderTwo)`
  border-left: 5px solid ${props => props.theme.greenLighter};
  padding: 8px 24px;
`;

const Padding = styled.div`
  padding: 24px 50px;
  ${props => props.isPaddingBottom && 'padding-bottom: 0px;'}
  p { 
    text-align: right;
  }

  @media(max-width: 600px) {
    padding: 16px 24px;
  }
`;

const Label = styled(Typo.HeaderFour)`
  ${props => props.margin && `margin: ${props.margin};`}

  ${props => props.disabled && `
    color: ${props.theme.lightGray} !important;
    filter: grayscale(100%);
    cursor: not-allowed;
    * {
      filter: grayscale(100%);
      cursor: not-allowed;
      pointer-events:none;
    }
  `}
`;

const SubLabel = styled(Typo.Paragraph)`
  text-align: left !important;
`;

const Important = styled.span`
  color: ${props => props.theme.red};
  margin-left: 4px;
`;

const MarginBottom = styled.div`
  margin-bottom: 18px;

  ${props => props.disabled && `
    position: relative;
    &:before {
      position: absolute;
      z-index: 999;
      content: '';
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: ${props.theme.lightGray};
      border-radius: 4px;
    }
    filter: grayscale(100%);
    cursor: not-allowed;
    * {
      color: grayscale(100%);
      filter: grayscale(100%);
      cursor: not-allowed;
      pointer-events:none;
    }
  `}
`;

const Textarea = styled(Form.Textarea)`
  height: 111px;
  border: 1px solid ${props => props.theme.lightGray1};
`;

const CheckBox = styled(Form.CheckBox)`
  margin: 36px 0;

  ${props => props.disabled && `
    filter: grayscale(100%);
    cursor: not-allowed;
    * {
      color: grayscale(100%);
      filter: grayscale(100%);
      cursor: not-allowed;
      pointer-events:none;
    }
  `}
`;

const Text = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const LabelCheckbox = styled(Text)`
  margin: 0px;
  text-align: left !important;
`;

const TextBlue = styled.span`
  color: ${props => props.theme.blue} !important;
`;

const Input = styled(_Input.Input)`
  height: 800px;
  background-color: red !important;
  * {
    color: red !important;
    border: none !important;
  }
`;

const StepOneForm = (props) => {
  const { signUpForm } = props;
  return (
    <Fragment>
      <TitleForm>Tell us more</TitleForm>
      <Padding isPaddingBottom>
        <Label>Tell us more about yourself<Important>*</Important></Label>
        <SubLabel>What makes you different from other influencers?</SubLabel>
        <MarginBottom>
          <Textarea
            type="text"
            name="aboutYourself"
            value={signUpForm.values.aboutYourself}
            onChange={(e) => signUpForm.change('aboutYourself', e.target.value)}
            errorMessage={signUpForm.errors.aboutYourself}
          />
        </MarginBottom>
        <Label>Are you a member of TakeMeTour affiliate program?</Label>
        <SubLabel>If yes, please fill in your affiliate ID.</SubLabel>
        <MarginBottom disabled={signUpForm.values.needToBeAffiliate}>
          <Input
            type="text"
            name="affiliateId"
            value={signUpForm.values.affiliateId}
            handleOnChange={(e) => (
              !signUpForm.values.needToBeAffiliate
                ? signUpForm.change('affiliateId', e.target.value)
                : () => {}
            )}
            errorMessage={signUpForm.errors.affiliateId}
          />
        </MarginBottom>
        <CheckBox
          checked={signUpForm.values.needToBeAffiliate}
          onChange={() => signUpForm.change('needToBeAffiliate', !signUpForm.values.needToBeAffiliate)}
          disabled={signUpForm.values.affiliateId}
          renderLabel={() => (
            <LabelCheckbox>
              <Label disabled={signUpForm.values.affiliateId} margin="2px 0px 0px">I would like to be <TextBlue><Link to="/affiliate" target="_blank" rel="noopener noreferrer">Affiliate Partner</Link></TextBlue></Label>
            </LabelCheckbox>
          )}
        />
        <Label>Which local tours would you like to join?<Important>*</Important></Label>
        <SubLabel>
          Please find our unique 1-day local tours in this link:<br/>
          <Link to="/" target="_blank" rel="noopener noreferrer">https://www.takemetour.com</Link> or provide the destination you would like to visit.
        </SubLabel>
        <MarginBottom>
          <Input
            type="text"
            name="tripName"
            value={signUpForm.values.tripName}
            handleOnChange={(e) => signUpForm.change('tripName', e.target.value)}
            errorMessage={signUpForm.errors.tripName}
          />
        </MarginBottom>
        <Label>How many people will go with you on this sponsored local tour?<Important>*</Important></Label>
        <SubLabel>For example: Family (2 adults and 2 kids).</SubLabel>
        <MarginBottom>
          <Input
            type="text"
            name="quantity"
            value={signUpForm.values.quantity}
            handleOnChange={(e) => signUpForm.change('quantity', e.target.value)}
            errorMessage={signUpForm.errors.quantity}
          />
        </MarginBottom>
        <Label>When do you plan to go on this sponsored local tour?<Important>*</Important></Label>
        <SubLabel>If there are more than one tour or destination please inform.</SubLabel>
        <MarginBottom>
          <Input
            type="text"
            name="planTrip"
            value={signUpForm.values.planTrip}
            handleOnChange={(e) => signUpForm.change('planTrip', e.target.value)}
          />
        </MarginBottom>
      </Padding>
    </Fragment>
  );
};

StepOneForm.propTypes = {
  signUpForm: PropTypes.object,
};

export default StepOneForm;
